import React from "react";
import { Sparkles } from "lucide-react";
import ResourceAdmin from "../../components/admin/ResourceAdmin";
import { adminApi } from "../../lib/api";

const ICON_OPTIONS = [
  "Footprints", "HeartHandshake", "MessagesSquare", "Megaphone", "Users", "Radio",
  "Building2", "GraduationCap", "Whistle", "Trophy", "Shield", "Rocket", "ShoppingBag",
].map((v) => ({ value: v, label: v }));

const COLOR_OPTIONS = [
  { value: "#E9A400", label: "Dorado" },
  { value: "#22A860", label: "Verde" },
  { value: "#2F5BEA", label: "Azul" },
  { value: "#7B3FBF", label: "Morado" },
  { value: "#C24141", label: "Rojo" },
  { value: "#0A1C30", label: "Navy" },
];

export default function SuperaXAdmin() {
  return (
    <div>
      <div className="mb-6 flex items-center gap-3">
        <span className="w-11 h-11 rounded-xl bg-[#0A1C30] grid place-items-center"><Sparkles className="w-6 h-6 text-[var(--gold)]" /></span>
        <div>
          <h1 className="text-2xl font-extrabold text-[#0A1C30]">Supera <span className="italic text-[var(--gold)]">X</span></h1>
          <p className="text-sm text-[#6B7688]">Administra las experiencias que ve el usuario. Edita el título, el resumen y la descripción de cada opción. (El contenido interno de cada experiencia se construirá en una etapa posterior.)</p>
        </div>
      </div>
      <ResourceAdmin
        title="Experiencias Supera X"
        subtitle="Reordena con 'Orden', desactiva las que aún no quieras mostrar y escribe la descripción que verá el usuario al abrir cada opción."
        resource={adminApi.resource("superax")}
        defaults={{ titulo: "", resumen: "", descripcion: "", icono: "Sparkles", color: "#E9A400", imagen_url: "", orden: 99, activo: true }}
        fields={[
          { name: "titulo", label: "Título", type: "text" },
          { name: "imagen_url", label: "Foto de la experiencia (inspira liderazgo)", type: "image", uploadFn: adminApi.superaxUploadImage },
          { name: "resumen", label: "Resumen corto (subtítulo)", type: "text", placeholder: "Una frase breve que aparece bajo el título" },
          { name: "descripcion", label: "Descripción completa", type: "textarea", placeholder: "Explica en qué consiste esta experiencia. Aparecerá al abrir la opción." },
          { name: "icono", label: "Icono (se usa si no hay foto)", type: "select", options: ICON_OPTIONS },
          { name: "color", label: "Color de acento", type: "select", options: COLOR_OPTIONS },
          { name: "orden", label: "Orden", type: "number" },
          { name: "activo", label: "Visible para el usuario", type: "switch" },
        ]}
        columns={[
          { name: "orden", label: "#", render: (i) => <span className="text-[#6B7688]">{i.orden}</span> },
          { name: "imagen_url", label: "Foto", render: (i) => i.imagen_url ? <img src={i.imagen_url} alt="" className="w-14 h-10 rounded-lg object-cover ring-1 ring-black/5" /> : <span className="text-xs text-[#9AA3B2]">— sin foto</span> },
          { name: "titulo", label: "Experiencia", render: (i) => <span className="font-bold text-[#0A1C30]">{i.titulo}</span> },
          { name: "descripcion", label: "Descripción", render: (i) => <span className="text-xs text-[#6B7688]">{i.descripcion ? `${i.descripcion.slice(0, 60)}${i.descripcion.length > 60 ? "…" : ""}` : "— (pendiente)"}</span> },
          { name: "activo", label: "Estado", render: (i) => <span className={`text-xs font-bold ${i.activo !== false ? "text-[#22A860]" : "text-[#9AA3B2]"}`}>{i.activo !== false ? "Visible" : "Oculta"}</span> },
        ]}
      />
    </div>
  );
}
